var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H7V12H6V6Z",
    fill: "#E66666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H10V12H9V6Z",
    fill: "#E66666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3V4H3V14C3 14.2652 3.10536 14.5196 3.29289 14.7071C3.48043 14.8946 3.73478 15 4 15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V4H14V3H2ZM4 14V4H12V14H4Z",
    fill: "#E66666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1H10V2H6V1Z",
    fill: "#E66666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveNewIcon);
export default __webpack_public_path__ + "static/media/remove-new-icon.d0a45f35c64ed88f02a425962d06c8eb.svg";
export { ForwardRef as ReactComponent };